import { SvrPubl } from "../utils/axios/index";
import { SvrConn } from "../utils/axios/index";

/**
 * Metodo para traer los datos de conexión con el cliente
 */
const login = async (usuario, password) => {
  let res = {};
  try {
    res = await SvrPubl.post("/api/auth/login", {
      usuario,
      password,
    });
  } catch (Error) {
    res = {
      status: 0,
      message: Error.message,
      Error: "Error en Cliente",
    };
  }
  return res;
};

/**
 * Valida token
 */
const getValidarToken = async (Token) => {
  let res = {};
  try {
    res = await SvrConn.get("/api/users/getValidarToken", {
      Token,
    });
  } catch (Error) {
    res = {
      status: 0,
      message: Error.message,
      Error: "Error en Cliente",
    };
  }
  return res;
};

export { login, getValidarToken };
